module.exports = __webpack_public_path__ + "img/weibo.01959430.png";